// import $ from 'jquery';
import React from 'react';
import Field from 'components/fields/Field';
// import PropTypes from 'prop-types';

class FieldCheckbox extends Field {
    constructor(props) {
        super(props);
    }
    // format(value) {
    // }
    validate() {
        const { checked, required , disabled } = this.props;

        let testChecked = true;
        if (required && !checked) {
            testChecked = false;
        }

        return super.validate() && testChecked;
    }
    handleClasses() {
        let fieldClassName = 'field--checkbox';
        const { overrideDefaultClassName } = this.props;

        if (
            typeof overrideDefaultClassName != 'undefined' &&
            overrideDefaultClassName != ''
        ) {
            fieldClassName = overrideDefaultClassName;
        }

        return super.handleClasses().concat(' ' + fieldClassName);
    }
    render() {
        const { checked , disabled } = this.props;

        return (
            <label
                className={this.handleClasses()}
                // data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
            >
                {super.renderAutoresize()}
                <input
                    disabled = {disabled}
                    className='field__input'
                    ref={(r) => (this.input = r)}
                    {...super.generateProps()}
                    type='checkbox'
                    checked={checked}
                />
                {super.renderValue()}
                {super.renderError()}
                {super.renderLoading()}
            </label>
        );
    }
}

export default FieldCheckbox;
